export default "__VITE_ASSET__2Cr9jqnB7BE1yLJKm74XVA__"